import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/form-requests']['POST'];

type Input = ThisApi['body'];
type Output = ThisApi['response'];

const createFormRequest = async (body: Input): Promise<Output> => {
  const data = await noodleApiClient.post('/form-requests', body);
  return data.data;
};

export default createFormRequest;
